import { validateEmail, validateName } from "../../../utils/validation";
import { useState } from "react";
import { Button, Input } from "src/components/shared";
import { useStore } from "../../../store";
import { useNavigate, useParams } from "react-router-dom";
import { addSessionToUser } from "src/store/session";

interface Props {
  email: string;
  setEmail: (email: string) => void;
  loading: boolean;
  setLoading: (prop: boolean) => void;
}

const FreeCheckoutForm = ({ email, setEmail, loading, setLoading }: Props) => {
  const { userStore } = useStore();
  const { id } = useParams();
  const navigate = useNavigate();

  const [fullName, setFullName] = useState(userStore?.user?.fullName || "");

  const pay = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    if (!userStore?.user) {
      const tempUser = await userStore.createTempUser({ email, fullName });
      localStorage.setItem("registrationStep", "2");
      localStorage.setItem(
        "registrationUser",
        JSON.stringify({ email, fullName })
      );
      addSessionToUser(id, tempUser.token.userId);
    } else {
      addSessionToUser(id, userStore.user.id);
    }
    navigate("/payment-success/" + id);
    setLoading(false);
  };

  return (
    <div
      className="flex flex-col gap-6 px-6 py-5 sm:p-10 w-full sm:w-3/5 h-fit bg-white rounded-[30px]"
      style={{ boxShadow: "0px 18px 26px -4px #00000005" }}
    >
      <form className="flex flex-col gap-3 sm:gap-5" onSubmit={pay}>
        <h3 className="body-medium-bold">Enroll into Class</h3>
        <div className="flex flex-col gap-3.5">
          <div className="flex flex-col gap-1.5 sm:gap-2.5">
            <h4 className="body-small-bold text-[#676767]">Your Details</h4>
            <Input
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              label="Full Name"
              placeholder="Enter your Name..."
              validation={validateName}
              required
            />
            <Input
              value={email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              label="Email Address"
              placeholder="Enter your Email..."
              validation={validateEmail}
              required
            />
          </div>
        </div>

        <div className="flex flex-col">
          <Button
            type="primary_dark"
            text={`Enroll for Free`}
            isLoading={loading}
            submit
          />
          <p className="caption-text text-primary-gray-400">
            By pressing Enroll, you agree to our{" "}
            <a
              className="underline hover:text-[#363636] transition-all duration-200"
              href="https://blog.classx.tech/terms"
              target="_blank"
            >
              Terms of Service
            </a>{" "}
            &{" "}
            <a
              className="underline hover:text-[#363636] transition-all duration-200"
              href="https://blog.classx.tech/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </form>
    </div>
  );
};

export default FreeCheckoutForm;
